import Footer from '../../components/common/Footer'
import RegisterFeatures from '../../components/registration/RegisterFeatures'
import RegisterNavbar from '../../components/registration/RegisterNavbar'

export default function RegisterFeaturePage() {
  return (
   <>
    <RegisterNavbar/>
    <RegisterFeatures/>
    <Footer/>
    </>
  )
}
